import {
  CCPPricingPlanContent,
  CCPPricingPlanTier,
  PricingStrategy,
  PricingTier
} from '@atlassiansox/asc-product-catalog';
import { PricingPlan, PricingPlans } from '.';
import { PricingPeriod } from '../models';

const HAMS_PRICING_STRATEGY_BY_CCP_PRICING_POLICY = {
  ['BLOCK']: PricingStrategy.FIXED_COST,
  ['MARGINAL_PER_UNIT']: PricingStrategy.MARGINAL_PER_UNIT,
  ['PER_UNIT']: PricingStrategy.PER_UNIT
};

const convertCCPPricingStrategyToHAMS = (
  ccpPricingPolicy: string
): PricingStrategy => {
  const hamsPricingStrategy =
    HAMS_PRICING_STRATEGY_BY_CCP_PRICING_POLICY[
      ccpPricingPolicy as 'BLOCK' | 'MARGINAL_PER_UNIT' | 'PER_UNIT'
    ];

  if (!hamsPricingStrategy) {
    throw new Error(
      `Could not find HAMS pricing strategy to match CCP pricing policy: "${ccpPricingPolicy}"`
    );
  }

  return hamsPricingStrategy;
};

const convertCCPTiersToHAMS = (
  ccpTiers: CCPPricingPlanTier[],
  chargeElement: string,
  currency: string
): PricingTier[] =>
  ccpTiers.map(ccpTier => ({
    starter: false,
    pricingStrategy: convertCCPPricingStrategyToHAMS(ccpTier.policy),
    unitDescription: chargeElement,
    unitLimitLower: ccpTier.floor,
    unitLimitUpper: ccpTier.ceiling,
    prices: [
      {
        currency,
        unitPrice: ccpTier.policy.includes('UNIT')
          ? ccpTier.unitAmount
          : ccpTier.flatAmount
      }
    ]
  }));

const convertCCPPricingPlansToHAMS = (
  pricingPlans: CCPPricingPlanContent[]
): PricingPlans => {
  const [monthlyCCP, annualCCP] = ['MONTH', 'YEAR'].map(primaryCycle =>
    pricingPlans.find(
      pricingPlan => pricingPlan.primaryCycle_interval === primaryCycle
    )
  );

  const [monthly, annual] = [monthlyCCP, annualCCP].map(ccpPPContent => {
    if (!ccpPPContent) {
      return undefined;
    }

    const { tiers, chargeElement } = ccpPPContent.items[0];
    return convertCCPTiersToHAMS(tiers, chargeElement, ccpPPContent.currency);
  });

  return {
    [PricingPeriod.MONTHLY]: monthly as PricingPlan,
    [PricingPeriod.ANNUAL]: annual as PricingPlan
  };
};

export { convertCCPPricingPlansToHAMS };
